import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import IconDemo from '../../components/IconDemo'
import Grid from '../../components/Grid'
import Downloadable from '../../components/Downloadable'
import Image from '../../components/Image'

import grid18 from '../../assets/images/brandbook/grid/grid.018.jpeg'

export const path = '/brandbook/product'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Product</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">
      <Section>
          <Grid grid="1-2">
            <></>
            <>
              <h2>Waved.app prototype</h2>
              <p>
              <Link to="/locations">
                My Locations
              </Link>
              <br />
              <Link to="/location">
                Location
              </Link>
              <br />
              <Link to="/location">
                Settings
              </Link>
              </p>
            </>
          </Grid>
      </Section>
      <Section>
        <Image imageUrl={grid18} aspect="16/9" />
      </Section>



    <br />
    </Container>
    </div>
    )
  }
